import DeviceMap from '../../features/DeviceMap/index.web';

const DeviceMapWidget = ({
  filtersCompact,
  setShowCurrentDevice,
  setShowDeviceSettings,
  selectedGroup,
  setSelectedGroup,
  usgsMapWidget,
}) => {
  return (
    <div className="h-100 w-100">
      <div className="bg-primary rounded-3 overflow-hidden w-100 h-100">
        <DeviceMap
          setShowCurrentDevice={setShowCurrentDevice}
          setShowDeviceSettings={setShowDeviceSettings}
          selectedGroup={selectedGroup}
          setSelectedGroup={setSelectedGroup}
          filtersCompact={filtersCompact}
          usgsMapWidget={usgsMapWidget}
          widget
        />
      </div>
    </div>
  );
};

export default DeviceMapWidget;
